import { css } from '@tools/wr-catalog-base'
import FilterDropdownButton from '@routes/List/Toolbar/FilterDropdownButton'
import SortingDropdownButton from '@routes/List/Toolbar/SortingDropdownButton'
import logo from 'assets/logo.png'

export default {
  palette: {
    primary: '#6c757d',
    secondary: 'rgba(108, 117, 125, 0.2)',
    primaryText: '#333333',
    background: '#FBF9F9',
    error: '#D63031',
    success: '#00b894',
    warning: '#FDCB6E',
    neutral: '#B2BEC3',
  },
  brand: {
    name: 'PTC Enterprise Success Program Service Catalog',
    tagline:
      'PTC Service Offerings are defined sets of activities and outputs that are designed to help our customers achieve specific business outcomes.',
    logo,
  },
  components: {
    native: {
      input: css`
        border: 1px solid ${({ theme }) => theme.palette.muted};
        border-radius: 0;
        padding: ${({ large }) => (large ? '0.64rem' : '0.375rem')} 0.75rem;
        color: ${({ theme }) => theme.palette.primaryText};
        line-height: 1em;
        font-size: 1em;
        transition: 0.2s ease-in-out box-shadow, 0.2s ease-in-out border;
        font-family: inherit;

        max-width: ${({ theme }) => theme.components.form?.width};
        ${({ fullWidth }) => fullWidth && 'max-width: 100%;'}
        width: 100%;

        &:focus {
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
          border-color: rgba(0, 123, 255, 0.25);
        }
      `,
      button: css`
        background-color: ${({ theme, outline = false, primary = true }) =>
          outline ? 'transparent' : primary ? theme.palette.primary : theme.palette.secondary};
        border: ${({ theme, outline = false, primary = true }) =>
          outline ? `1px solid ${primary ? theme.palette.primary : theme.palette.secondary}` : `1px solid transparent`};
        color: ${({ theme, outline = false, primary = true }) =>
          outline ? (primary ? theme.palette.primary : theme.palette.secondary) : theme.palette.secondaryText};
        border-radius: 0;
        transition: filter 0.1s ease-in, opacity 0.1s ease-in, background-color 0.1s ease-in;
        line-height: 1em;
        font-size: 1em;
        position: relative;
        padding: 0.5rem 1rem;
        ${({ fullWidth }) => fullWidth && 'width: 100%;'}
        ${({ small }) =>
          small &&
          `
        font-size: 0.8em;
        line-height: 0.8em;
        padding: 0.25rem 0.5rem;
      `}

      ${({ large }) =>
          large &&
          `
        font-size: 1.3em;
        line-height: 1.3em;
      `}

      ${({ success, theme }) =>
          success &&
          `
        background-color: ${theme.palette.success};
      `}

      ${({ warning, theme }) =>
          warning &&
          `
        background-color: ${theme.palette.warning};
      `}

      ${({ error, theme }) =>
          error &&
          `
        background-color: ${theme.palette.error};
      `}

      ${({ custom, theme }) =>
          custom &&
          `
        background-color: ${theme.palette.custom};
      `}

      ${({ customFilter, theme }) =>
          customFilter &&
          `
        filter: ${theme.palette.customFilter};
      `}

      &:hover {
          filter: brightness(1.1);
        }

        &[disabled] {
          opacity: 0.5;
          cursor: not-allowed;
          filter: none;
        }

        svg {
          margin-right: 5px;
          display: inline-block;
          vertical-align: top;
        }
      `,
    },
    inputWrapper: css`
      display: block;
      position: relative;
      padding: 0;
      ${({ fullWidth }) => fullWidth && ' width: 100%;'}
    `,
    searchBox: {
      wrapper: css`
        max-width: ${({ theme }) => theme.components.form?.width};
        ${({ fullWidth }) => fullWidth && 'max-width: 100%;'}
        width: 100%;
      `,
      input: css`
        width: 100%;
        max-width: 100%;
      `,
      icon: css`
        margin-right: 15px;
        font-size: 18px;
      `,
    },
    hero: {
      backgroundImage: 'none',
      backgroundPosition: '50% 80%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      height: '300px',
      padding: '55px 0',
      top: '50%',

      brandName: {
        brandNameHeight: '52px',
        brandNameFontWeight: '500',
      },
      tagline: {
        taglineHeight: '13px',
        taglineLineHeight: '1.5',
        taglineMaxWidth: '1000px',
        taglineMargin: '0 auto',
      },
    },
    checkboxGroup: {
      hiddenInput: css`
        position: absolute;
        width: 1rem;
        height: 1rem;
        opacity: 0;
        cursor: pointer;
        z-index: 1;
      `,
    },
    card: {
      borderColor: '#ddd',
      borderColorHover: '#ccc',
      borderRadius: '0',
      selectedIconColor: '#888',
    },
    dropdown: {
      borderRadius: '5px',
      container: css`
        position: relative;
      `,
      list: css`
        position: absolute;
        min-width: 100%;
        z-index: 10;
        margin-top: 3px;
        border: ${({ theme }) => theme.components.dropdown.border};
        border-radius: ${({ theme }) => theme.components.dropdown.borderRadius};
        background-color: ${({ theme }) => theme.components.dropdown.buttonsBackgroundColor};

        button,
        a {
          display: inline-block;
          text-align: left;
          text-decoration: none;
          color: ${({ theme }) => theme.components.dropdown.color};
          background-color: ${({ theme }) => theme.components.dropdown.buttonsBackgroundColor};
          padding: 10px;

          &:hover {
            background-color: ${({ theme }) => theme.components.dropdown.buttonsBackgroundColorHover};
            opacity: 1;
          }
        }

        svg {
          margin-left: 10px;
        }
      `,
      color: '#333',
      border: '1px solid #ddd',
      buttonsBackgroundColor: '#FFF',
      buttonsBackgroundColorHover: '#ddd',
    },
    navbar: {
      height: '81px',
      position: 'fixed',
      backgroundColor: '#fff',
      color: '#999',
    },
    decisionTree: {
      questions: {
        fontSize: '18px',
        finalQuestionFontWeight: 'normal',
      },
      displaySelectedIcon: true,
      answers: {
        backgroundColor: '#e0e0e0',
        border: '1px solid #d6d6d6',
        color: '#333',
        selectedAnswer: '#e0e0e0',
        selectedAnswerBorder: '1px solid #afafaf',
        hoverBoxShadow: '0px 0px 3px rgba(0,0,0,0.2)',
        selectedAnswerColor: 'inherit',
        displaySelectedIcon: false,
        questionSummaryColor: css`
          ${({ theme }) => theme.palette.primary}
        `,
        answerSummaryColor: '#5a5a5a',
        width: '100%',
        helpText: {
          color: '#626262',
          fontSize: '14px',
          display: 'block',
        },
      },
      footer: {
        buttonBorderRadius: '5px',
        buttonPadding: '10px 20px',
      },
      radio: {
        checkedColor: '#fff',
      },
    },
    dropdownInput: {
      selectedColor: '#CED4DA',
    },
    modal: {
      borderRadius: '5px',
      confirmation: {
        buttons: {
          borderRadius: '5px',
          padding: '0.75rem 1rem',
        },
      },
    },
    button: {
      borderRadius: '0.2rem',
    },
    tabs: {
      linksWrapper: {
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          bottom: 10,
          width: '100%',
          height: 1,
          backgroundColor: '#eaeaea',
        },
      },
      indicator: {
        backgroundColor: 'initial',
        position: 'relative',
        '&:before, &:after': {
          content: '""',
          width: 0,
          height: 0,
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: -6,
          margin: 'auto',
        },
        '&:before': {
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderBottom: '10px solid #eaeaea',
        },
        '&:after': {
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderBottom: '8px solid #fff',
        },
      },
      disableIndicatorScalingAnimation: true,
    },
    productList: {
      toolbar: {
        filtersDropdown: {
          buttonComponent: FilterDropdownButton,
        },
        sortingDropdown: {
          buttonComponent: SortingDropdownButton,
        },
      },
    },
    productDetails: {
      cart: {
        sticky: true,
      },
    },
  },
}
